<template>
  <div>
    <Toolbar title="404" />
    <div>Four oh Four!</div>
  </div>
</template>
<script>
import Toolbar from "./Toolbar.vue";

export default {
  components: {
    Toolbar,
  },
};
</script>
